<div class="aide-recherche" [class.aide-recherche--grand]="grand()">
  <p-iconfield>
    <p-inputicon styleClass="fa-light fa-magnifying-glass" />
    <input pInputText type="search" class="w-full" autocomplete="off"
           placeholder="Que voulez-vous faire ?" aria-label="Rechercher dans l'aide"
           [ngModel]="requete()" (ngModelChange)="saisir($event)" (keydown.enter)="valider()" />
  </p-iconfield>

  @let liste = resultats();
  @if (liste !== null) {
    @if (liste.length) {
      <ul class="aide-recherche__resultats">
        @for (r of liste; track r.slug) {
          <li>
            <button type="button" class="aide-recherche__resultat" (click)="choisir.emit(r.slug)">
              <span class="aide-recherche__titre">{{ r.titre }}</span>
              @if (r.extrait) {
                <span class="aide-recherche__extrait">{{ r.extrait }}</span>
              }
            </button>
          </li>
        }
      </ul>
    } @else {
      <p class="aide-recherche__vide">Aucun tuto ne correspond. Essayez avec d'autres mots, par exemple « facture » ou « paiement ».</p>
    }
  }
</div>
